import React, { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export function Seo({ title, description, noindex = false, canonicalPath }) {
  useEffect(() => {
    const fullTitle = title
      ? (title.includes("Hallo Suiza") ? title : `${title} · Hallo Suiza`)
      : "Hallo Suiza · Aprende alemán para vivir y trabajar en Suiza";
    document.title = fullTitle;
    const desc = description || "Academia interactiva de alemán, guías prácticas y vocabulario suizo para hispanohablantes en Suiza.";
    const setMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setProp = (prop, content) => {
      let el = document.querySelector(`meta[property="${prop}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("property", prop); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    setMeta("description", desc);
    setMeta("robots", noindex ? "noindex, nofollow" : "index, follow");
    // Canonical y og:url por página (siempre con el dominio de producción)
    const path = (canonicalPath || (typeof window !== "undefined" ? window.location.pathname : "/")).replace(/\/+$/, "");
    const canonical = "https://hallosuiza.com" + path;
    const setLink = (rel, href) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };
    setLink("canonical", canonical);
    setProp("og:url", canonical);
    setProp("og:title", fullTitle);
    setProp("og:description", desc);
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", desc);
    return () => { setMeta("robots", "index, follow"); };
  }, [title, description, noindex, canonicalPath]);
  return null;
}

export default function Layout({ children }) {
  return (
    <div className="App flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export function BareLayout({ children }) {
  return <div className="App min-h-screen">{children}</div>;
}
